module.exports = __webpack_public_path__ + "img/multidays.83b96747.svg";